import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ShellComponent } from 'src/core/components';
import { AdminAtLeastGuard, AuthorizedGuard, UnauthorizedGuard } from 'src/core/guards';
import { OwnerGuard } from 'src/core/guards/Owner';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: '/home' },
    {
        path: '', component: ShellComponent,
        canActivate: [AuthorizedGuard],
        children: [
            {
                path: 'home',
                loadChildren: () =>
                    import('../modules/home/home.component').then(m => m.HomeModule),
                canActivate: [AuthorizedGuard]
            },

            {
                path: 'account/change-email',
                loadChildren: () =>
                    import('../modules/change-email/change-email').then(m => m.ChangeEmailModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'account/change-password',
                loadChildren: () =>
                    import('../modules/change-password/change-password').then(m => m.ChangePasswordModule),
                canActivate: [AuthorizedGuard]
            },

            {
                path: 'logs',
                loadChildren: () =>
                    import('../modules/logs/logs').then(m => m.LogsModule),
                canActivate: [AuthorizedGuard]
            },

            {
                path: 'report-reasons',
                loadChildren: () =>
                    import('../modules/report-reasons/report-reasons').then(m => m.ReportReasonsModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'report-reasons/addnew',
                loadChildren: () =>
                    import('../modules/report-reasons-edit/report-reasons-edit').then(m => m.ReportReasonEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'report-reasons/edit/:id',
                loadChildren: () =>
                    import('../modules/report-reasons-edit/report-reasons-edit').then(m => m.ReportReasonEditModule),
                canActivate: [AuthorizedGuard]
            },

            {
                path: 'goals',
                loadChildren: () =>
                    import('../modules/goals/goals').then(m => m.GoalsModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'goals/addnew',
                loadChildren: () =>
                    import('../modules/goals-edit/goals-edit').then(m => m.GoalsEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'goals/edit/:id',
                loadChildren: () =>
                    import('../modules/goals-edit/goals-edit').then(m => m.GoalsEditModule),
                canActivate: [AuthorizedGuard]
            },

            {
                path: 'verification-request-rejections',
                loadChildren: () =>
                    import('../modules/verification-requests-rejections/verification-requests-rejections')
                        .then(m => m.VerificationRequestRejectionsModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'verification-request-rejections/addnew',
                loadChildren: () =>
                    import('../modules/verification-requests-rejections-edit/verification-requests-rejections-edit')
                        .then(m => m.VerificationRequestRejectionsEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'verification-request-rejections/edit/:id',
                loadChildren: () =>
                    import('../modules/verification-requests-rejections-edit/verification-requests-rejections-edit')
                        .then(m => m.VerificationRequestRejectionsEditModule),
                canActivate: [AuthorizedGuard]
            },

            {
                path: 'users',
                loadChildren: () =>
                    import('../modules/users/users.module').then(m => m.UsersModule),
                canActivate: [AuthorizedGuard, AdminAtLeastGuard]
            },

            {
                path: 'staff',
                loadChildren: () =>
                    import('../modules/staff/staff').then(m => m.UsersModule),
                canActivate: [AuthorizedGuard, AdminAtLeastGuard]
            },
            {
                path: 'staff/addnew',
                loadChildren: () =>
                    import('../modules/staff-edit/staff-edit').then(m => m.EditUserModule),
                canActivate: [AuthorizedGuard, AdminAtLeastGuard]
            },
            {
                path: 'staff/edit/:id',
                loadChildren: () =>
                    import('../modules/staff-edit/staff-edit').then(m => m.EditUserModule),
                canActivate: [AuthorizedGuard, AdminAtLeastGuard]
            },

            {
                path: 'edit-profile',
                loadChildren: () =>
                    import('../modules/edit-profile/edit-profile').then(m => m.EditProfileModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'reported-users',
                loadChildren: () =>
                    import('../modules/reported-users/reported-users').then(m => m.ReportedUsersModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'reported-posts',
                loadChildren: () =>
                    import('../modules/reported-posts/reported-posts').then(m => m.ReportedPostsModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'reported-comments',
                loadChildren: () =>
                    import('../modules/reported-comments/reported-comments').then(m => m.ReportedCommentsModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'reported-groups',
                loadChildren: () =>
                    import('../modules/reported-groups/reported-groups').then(m => m.ReportedGroupsModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'verification-requests',
                loadChildren: () =>
                    import('../modules/verification-requests/verification-requests').then(m => m.VerificationRequestsModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'verification-requests/edit/:id',
                loadChildren: () =>
                    import('../modules/verification-requests-edit/verification-requests-edit').then(m => m.EditVerificationRequestModule),
                canActivate: [AuthorizedGuard]
            },

            {
                path: 'send-notifications',
                loadChildren: () =>
                    import('../modules/send-notifications/send-notifications').then(m => m.SendPushNotificationModule),
                canActivate: [AuthorizedGuard]
            },

            {
                path: 'settings',
                loadChildren: () =>
                    import('../modules/settings/settings').then(m => m.SettingsModule),
                canActivate: [AuthorizedGuard, OwnerGuard]
            },
            {
                path: 'cities',
                loadChildren: () =>
                    import('../modules/cities/cities').then(m => m.CitiesModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'cities/addnew',
                loadChildren: () =>
                    import('../modules/cities-edit/cities-edit').then(m => m.CitiesEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'cities/edit/:id',
                loadChildren: () =>
                    import('../modules/cities-edit/cities-edit').then(m => m.CitiesEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'coupons',
                loadChildren: () => import('../modules/coupons/coupons.module').then(m => m.CouponsModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'coupons/addnew',
                loadChildren: () => import('../modules/coupons/coupon-edit/coupon-edit.component').then(m => m.CouponEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'coupons/edit/:id',
                loadChildren: () => import('../modules/coupons/coupon-edit/coupon-edit.component').then(m => m.CouponEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'coupons/details/:id',
                loadChildren: () => import('../modules/coupons/coupon-edit/coupon-edit.component').then(m => m.CouponEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'banners',
                loadChildren: () => import('../modules/banners/banners.module').then(m => m.BannersModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'banners/addnew',
                loadChildren: () => import('../modules/banners/banner-edit/banner-edit.component').then(m => m.BannerEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'banners/edit/:id',
                loadChildren: () => import('../modules/banners/banner-edit/banner-edit.component').then(m => m.BannerEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'banners/details/:id',
                loadChildren: () => import('../modules/banners/banner-edit/banner-edit.component').then(m => m.BannerEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'partnerships',
                loadChildren: () => import('../modules/partnerships/partnerships.module').then(m => m.PartnershipsModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'orders',
                loadChildren: () => import('../modules/orders/orders.module').then(m => m.OrdersModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'partnerships/addnew',
                loadChildren: () => import('../modules/partnerships/partnership-edit/partnership-edit.component').then(m => m.PartnershipEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'partnerships/edit/:id',
                loadChildren: () => import('../modules/partnerships/partnership-edit/partnership-edit.component').then(m => m.PartnershipEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'partnerships/details/:id',
                loadChildren: () => import('../modules/partnerships/partnership-edit/partnership-edit.component').then(m => m.PartnershipEditModule),
                canActivate: [AuthorizedGuard]
            },
            {
                path: 'home-order',
                loadChildren: () =>
                    import('../modules/home-order/home-order').then(m => m.HomeOrderModule),
                canActivate: [AuthorizedGuard, OwnerGuard]
            },
        ]
    },
    {
        path: 'account/login',
        loadChildren: () => import('../modules/login/login.component').then(m => m.LoginModule),
        canActivate: [UnauthorizedGuard]
    },
    {
        path: 'account/recover-password',
        loadChildren: () => import('../modules/login-recover-password/recover-password.component').then(m => m.RecoverPasswordModule),
        canActivate: [UnauthorizedGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
